import { Search } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import type { ReactElement } from 'react'

import { useEcosystemSearch } from '@/features/ecosystem/api/ecosystem-api'
import { filterEcosystemItems } from '@/features/ecosystem/components/ecosystem-search-filter'

export function EcosystemSearch(): ReactElement {
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const { items } = useEcosystemSearch()

  const results = filterEcosystemItems(items, query)
  const showDropdown = open && query.trim().length > 0

  return (
    <div className="relative w-full max-w-[340px]">
      <div className="flex items-center gap-2 rounded-full border border-gold/30 bg-[rgba(0,15,24,0.6)] px-4 py-2.5 focus-within:border-gold">
        <Search className="h-4 w-4 shrink-0 text-gold-2" aria-hidden="true" />
        <input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          onKeyDown={(event) => {
            if (event.key === 'Escape') setOpen(false)
          }}
          placeholder="Buscar produto, BU, tema…"
          aria-label="Buscar no ecossistema"
          className="w-full bg-transparent text-[0.85rem] text-white placeholder:text-[#7E929D] focus:outline-none"
        />
      </div>

      {showDropdown && (
        <ul className="absolute left-0 right-0 top-[calc(100%+8px)] z-50 max-h-[60vh] overflow-auto rounded-[14px] border border-gold/[0.22] bg-[rgba(4,18,28,0.97)] py-2 shadow-xl backdrop-blur-[12px]">
          {results.length === 0 ? (
            <li className="px-4 py-3 text-[0.82rem] text-eco-muted">
              Nenhum resultado para “{query.trim()}”.
            </li>
          ) : (
            results.map((item) => (
              <li key={`${item.kind}-${item.to}`}>
                <Link
                  to={item.to}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => {
                    setQuery('')
                    setOpen(false)
                  }}
                  className="flex min-h-[44px] flex-col justify-center px-4 py-2 transition-colors hover:bg-gold/10"
                >
                  <span className="text-[0.88rem] text-white">{item.label}</span>
                  <span className="text-[0.72rem] uppercase tracking-[0.08em] text-gold-2">
                    {item.sublabel}
                  </span>
                </Link>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  )
}
